import React from 'react'

import useStyles from './tip-success-modal.style'

import { useDispatch, useSelector } from 'react-redux'
import { selectShowTipSuccessModal, selectTipConfirmationText } from '@selectors'
import { TIP_MODAL_CLOSE } from '@redux/actions/types'

import {
  BUTTON_CLOSE,
  MODAL_BODY_TIP_TITLE,
  MODAL_BODY_TIP_BODY,
  MODAL_BODY_TIP_EMERGENCY
} from '../../assets/i18n/strings'
import i18n from 'i18n-js'

import { Button, IconInline, Paragraph, Title, WHITE } from '@omnilert/components'

import Modal from '@components/modal/modal.component'

const TipSuccessModal = props => {
  const classes = useStyles(props)

  const dispatch = useDispatch()

  const isVisible = useSelector(selectShowTipSuccessModal)

  const confirmationText = useSelector(selectTipConfirmationText)

  const handleOnClickClose = () => {
    dispatch({ type: TIP_MODAL_CLOSE })
  }

  return (
    <Modal isVisible={isVisible}>
      <div>
        <div className={classes.iconContainer}>
          <IconInline
            className={classes.icon}
            name='check'
            rotate={0}
            size={162}
          />
        </div>
        <div className={classes.modalTextContainer}>
          <Title
            color={WHITE}
            size='md'
          >
            {i18n.t(MODAL_BODY_TIP_TITLE)}
          </Title>
          <Paragraph
            className={classes.body}
            color={WHITE}
            size='lg'
          >
            {confirmationText || i18n.t(MODAL_BODY_TIP_BODY)}
          </Paragraph>
          <Paragraph
            color='orange'
            size='md'
          >
            {i18n.t(MODAL_BODY_TIP_EMERGENCY)}
          </Paragraph>
        </div>
        <Button
          className={classes.button}
          fullWidth
          onClick={handleOnClickClose}
          title={i18n.t(BUTTON_CLOSE)}
          variant='solid'
        />
      </div>
    </Modal>
  )
}

export default TipSuccessModal
